import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/backend/api';

const publicApi = axios.create({
    baseURL: API_URL,
    headers: { 'Content-Type': 'application/json' },
});

export default publicApi;
